<form [formGroup]="form" (ngSubmit)="submit()">
    <app-input formControlName="password" encrypted="true" label="Nueva contraseña"></app-input>
    <app-input formControlName="repeatPassword" encrypted="true" label="Repetir contraseña"></app-input>

    <div class="button-container">
        <fs-ui-button  [action]="'submit'" (click)="submit()"  [label]="'Confirmar'"></fs-ui-button>
    </div>

</form>